module.exports = ""


//////////////////
// WEBPACK FOOTER
// C:/Users/Thomas/Projekte/palettes/src/app/shared/components/codeblock/codeblock.component.html
// module id = ../../../../../src/app/shared/components/codeblock/codeblock.component.html
// module chunks = main